<template>
  <div>
    <Slider/>
    <TrackTrace/>
    <Alliance/>
    <Wblog/>
    <CoreService/>

  </div>
</template>

<script>
import Slider from "./components/slider";
import TrackTrace from "./components/track-trace";
import Alliance from "./components/alliance";
import Wblog from "./components/wblog";
import CoreService from "./components/core-service/index.vue";


export default {
  name: "Home",
  components: {
    Slider,
    TrackTrace,
    Alliance,
    Wblog,
    CoreService,
  },
};
</script>

